export const DAYS = 31;
export const START_YEAR = 1960;
export const MONTHS = [{
  id: 0,
  title: 'Январь'
},{
  id: 1,
  title: 'Февраль'
},{
  id: 2,
  title: 'Март'
},{
  id: 3,
  title: 'Апрель'
},{
  id: 4,
  title: 'Май'
},{
  id: 5,
  title: 'Июнь'
},{
  id: 6,
  title: 'Июль'
},{
  id: 7,
  title: 'Август'
},{
  id: 8,
  title: 'Сентябрь'
},{
  id: 9,
  title: 'Остябрь'
},{
  id: 10,
  title: 'Ноябрь'
},{
  id: 11,
  title: 'Декабрь'
}];
